import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { TrendingUp, BarChart3, Gauge, Wallet, Package, PieChart, Donut } from "lucide-react";
import Skeleton from '@mui/material/Skeleton';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import { Table, TableBody, TableBuildingTag, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow } from "../../../../component/table/table-layout";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import { FeildWraper, FormCheckbox } from "../../../../component/form/form-layout";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Card, CardContent, CardHeader, CardTitle, KPI, TitleHeading } from "../../../../component/ui/layout";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import OverviewQuickView from "./popup";
import StatusChip from "../../../../component/ui/chip/status";

export default function OfficeAssetOrgOverview() {
  const apiCall = useApiCall();
  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);
  const [isTrendLoad, setIsTrendLoad] = useState(false);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format("YYYY-MM"));
  const [activeChart, setActiveChart] = useState("By Cost");
  const [activeMainChart, setActiveMainChart] = useState("By Cost");
  const [kpiData, setKpiData] = useState({});
  const [allTime, setAllTime] = useState(false);
  const [allTimeLoader, setAllTimeLoader] = useState(false);
  const [auditData, setAuditData] = useState({});
  const [quickOpenData, setQuickOpenData] = useState({isOpen: false})

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);
    if(allTime){
      setAllTime(false)
    }
    try {
      const resp = await apiCall({ method: "get", url: `office-asset/summary/overview?month=${selectedMonth}` }); //
      setDashboardData(resp);
      // setKpiData(resp?.stats)
      setIsDashboardApiLoaded(true);
      setAllTimeLoader(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  }

  const getAuditData = async() => {
    try {
      let apiRes = await apiCall({method: "get", url: "electricity-bills/reports/audit-exceptions"})
      setAuditData(apiRes)
      setQuickOpenData({
        isOpen: true,
        icon: <Wallet />,
        title: "Over Due Unpaid",
        data: apiRes?.overdueUnpaid,
        header:[
          {key: "billing_month", value: "Billing Month"}, 
          {key: "due_date", value: "Due Date"},
          {key: "location", value: "Location"}, 
          {key: "amount", value: "Amount"},
          {key: "days_overdue", value: "Days Overdue"},
          {key: "issue", value: "Issue"},
          {key: "severity", value: "Severity"},
        ]
      })
    } catch (error) {
      console.log("Error", error)
    }
  }

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth]);

  const getMonthlyTrend = async () => {
    try {
      const resp = await apiCall({ method: "get", url: `get-monthly-purchase-trends` });
      setMonthlyTrend(resp.data);
      setIsTrendLoad(true);
    } catch (error) {
      console.log("Err", error)
    }
  }

  useEffect(() => {
    getAuditData();
    getMonthlyTrend();
  }, []);

  const locationData = activeMainChart === "By Cost" ? dashboardData?.repairs_by_office?.map(item => ({
    name: item.office,       // X-axis label
    y: item.cost     // Column value
  })) :  dashboardData?.repairs_by_office?.map(item => ({
    name: item.office,       // X-axis label
    y: item.count     // Column value
  }));

  const monthlyChart = {
    chart: {
      type: "column" // ✅ Column chart
    },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      type: "category", // Use category names as X-axis
      title: { text: null }
    },
    yAxis: {
      title: "none",
      labels: {
        formatter: function () {
          return this.value.toLocaleString();
        }
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      pointFormat: `<b>${activeMainChart === "By Cost" ? "PKR" : ""} {point.y}</b>`
    },

    plotOptions: {
      column: {
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          format: `${activeMainChart === "By Cost" ? "PKR" : ""} {point.y}`
        }
      }
    },

    series: [
      {
        name: "Repairs By Office",
        data: locationData
      }
    ]
  };

  // const columnData = activeChart === "By Cost" ? dashboardData?.location_summary?.map(item => ({
  //   name: item.name,       // X-axis label
  //   y: item.total_cost     // Column value
  // })) :  dashboardData?.location_summary?.map(item => ({
  //   name: item.name,       // X-axis label
  //   y: item.units     // Column value
  // }));

  // const serviceOptions = {
  //   chart: {
  //     type: "column" // ✅ Column chart
  //   },
  //   title: { text: null },
  //   credits: { enabled: false },
  //   xAxis: {
  //     type: "category", // Use category names as X-axis
  //     title: { text: null }
  //   },
  //   yAxis: {
  //     title: { text: "Amount (PKR)" },
  //     labels: {
  //       formatter: function () {
  //         return this.value.toLocaleString();
  //       }
  //     }
  //   },
  //   legend: {
  //     enabled: false
  //   },
  //   tooltip: {
  //     pointFormat: `<b>${activeChart === "By Cost" ? "PKR" : ""} {point.y:,.2f}</b>`
  //   },

  //   plotOptions: {
  //     column: {
  //       colorByPoint: true,
  //       dataLabels: {
  //         enabled: true,
  //         format: `${activeChart === "By Cost" ? "PKR" : ""} {point.y:,.2f}`
  //       }
  //     }
  //   },

  //   series: [
  //     {
  //       name: "Amount",
  //       data: columnData
  //     }
  //   ]
  // };


  const pieOptions = {
    chart: {
      type: "pie"
    },
    title: "none",
    credits: { enabled: false },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.count}</b><br/>Percentage: <b>{point.percentage:.1f}%</b>"
    },
    accessibility: {
      point: {
        valueSuffix: "%"
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.count})"
        }
      },
    },
    series: [
      {
        name: "Status",
        colorByPoint: true,
        data: dashboardData?.repairs_by_status?.map((obj) => ({
          count: activeChart == "By Cost" ? obj?.cost : obj?.count,
          name: obj?.status,
          y: parseFloat(activeChart == "By Cost" ? obj?.cost : obj?.count)
        }))
      }
    ],
    legend: { enabled: false },
  };


  const changeAllTime = (e) => {
    setAllTimeLoader(false)
    setAllTime(e);
    setKpiData(e ? (dashboardData?.totals) : (dashboardData?.monthly_spending))

    setTimeout(() => {
      setAllTimeLoader(true)
    }, 250);
  }

  const inputRef = useRef()
  
  const openMonthPicker = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker()
    } else {
      inputRef.current?.focus()
      inputRef.current?.click()
    }
  }

  return (
    <>
      <div className="pt-[20px] overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            <TitleHeading>Assets Overview</TitleHeading>
            <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
              {/* <FeildWraper className="!w-fit !flex-[0_0_auto] min-w-0 !px-0 !py-0">
                <FormCheckbox
                  label="All Time"
                  name="all_time"
                  checked={allTime}
                  onChange={(e) => changeAllTime(e.target.checked)}
                  className={'!w-[100px]'}
                />
              </FeildWraper> */}
              {/* <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
                <div className="relative">
                  <input type="month" ref={inputRef} className="absolute opacity-0 pointer-events-none" max={moment(new Date()).format("YYYY-MM")} value={selectedMonth} onChange={(e) => { setSelectedMonth(e.target.value) }} />

                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={false} className="btnClass">
                      <h3 className="!text-[16px] px-5 py-1">{moment(selectedMonth, "YYYY-MM").format("MMMM YYYY")}</h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">

                      <CustomDropdownMenuList>
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Last month
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList onClick={openMonthPicker}>
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Custom Month
                        </div>
                      </CustomDropdownMenuList>
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </div>
              </FeildWraper> */}
            </div>
          </div>

          {/* KPI Row */}
          <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
            <div className="pb-2">
              <TitleHeading>Asset Summary</TitleHeading>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
              {(isDashboardApiLoaded) ? (
                <>
                  <KPI
                    icon={Gauge}
                    value={dashboardData?.kpis?.total_assets}
                    label="Total Assets"
                    extraClass={"theme"}
                    // sublabel={allTime ? "All-time Entries" : `${moment(selectedMonth).format("MMM YYYY")} Entries`}
                  />

                  <KPI
                    icon={Wallet}
                    // value={kpiData?.total_units}
                    value={dashboardData?.kpis?.active_repairs}
                    label={"Active Repairs"}
                    // label={allTime ? "Total Units" : "Total Units"}
                    // sublabel={allTime ? "All-time Expenditure (PKR)" : `${moment(selectedMonth).format("MMM YYYY")} Expenditure (PKR)`}
                  />

                  <KPI
                    icon={Package}
                    value={dashboardData?.kpis?.pending_tasks}
                    label={"Pending Tasks"}
                    // sublabel={allTime ? "Lifetime Quantity" : `${moment(selectedMonth).format("MMM YYYY")} Quantity`}
                  />

                  <KPI
                    icon={BarChart3}
                    value={dashboardData?.kpis?.assets_needing_attention}
                    label={"Assets Needing Attention"}
                    // sublabel={allTime ? "All-time Average per Entry" : `${moment(selectedMonth).format("MMM YYYY")} Average per Entry`}
                  />

                  {/* <KPI
                    extraClass={"green"}
                    icon={TrendingUp}
                    value={kpiData?.highest_usage_location?.total_cost || "-"}
                    label={"Highest Usage"}
                    sublabel={kpiData?.highest_usage_location?.name || "-"}
                  /> */}

                  {/* <KPI
                    icon={Wallet}
                    value={auditData?.overdueUnpaid?.length}
                    label={"Over Due Unpaid"}
                    onClick={() => {
                      setQuickOpenData({
                        isOpen: true,
                        icon: <Wallet />,
                        title: "Over Due Unpaid",
                        data: auditData?.overdueUnpaid,
                        header:[
                          {key: "billing_month", value: "Billing Month"}, 
                          {key: "due_date", value: "Due Date"},
                          {key: "location", value: "Location"}, 
                          {key: "amount", value: "Amount"},
                          {key: "days_overdue", value: "Days Overdue"},
                          {key: "issue", value: "Issue"},
                          {key: "severity", value: "Severity"},
                        ]
                      })
                    }}
                    // sublabel={`Current Month Expenditure (PKR)`}
                  />

                  <KPI
                    icon={Wallet}
                    value={auditData?.abnormalSpike?.length}
                    label={"Abnormal Spike"}
                    onClick={() => {
                      setQuickOpenData({
                        isOpen: true,
                        icon: <Wallet />,
                        title: "Abnormal Spike",
                        data: auditData?.abnormalSpike,
                        header:[
                          {key: "month", value: "Month"}, 
                          {key: "previous_units", value: "Previous Units"},
                          {key: "current_units", value: "Current Units"}, 
                          {key: "issue", value: "Issue"},
                          {key: "severity", value: "Severity"},
                        ]
                      })
                    }}
                    // sublabel={`Current Month Expenditure (PKR)`}
                  />

                  <KPI
                    icon={Wallet}
                    value={auditData?.rateOutliers?.length}
                    label={"Rate Outliers"}
                    onClick={() => {
                      setQuickOpenData({
                        isOpen: true,
                        icon: <Wallet />,
                        title: "Rate Outliers",
                        data: auditData?.rateOutliers,
                        header:[
                          {key: "billing_month", value: "Billing Month"}, 
                          {key: "rate_per_unit", value: "Rate Per Unit"},
                          {key: "rate_per_unit_range", value: "Rate Per Unit"}, 
                          {key: "issue", value: "Issue"},
                          {key: "severity", value: "Severity"},
                        ]
                      })
                    }}
                    // sublabel={`Current Month Expenditure (PKR)`}
                  /> */}
                </>
              ) : (
                Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            <div className="py-2">
              <TitleHeading>Repair Cost Summary</TitleHeading>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
              {(isDashboardApiLoaded) ? (
                <>
                  <KPI
                    icon={Gauge}
                    value={dashboardData?.cost_summary?.total_repair_cost}
                    label="Total Repair Cost"
                    extraClass={"theme"}
                    // sublabel={allTime ? "All-time Entries" : `${moment(selectedMonth).format("MMM YYYY")} Entries`}
                  />

                  <KPI
                    icon={Wallet}
                    // value={kpiData?.total_units}
                    value={dashboardData?.cost_summary?.facility_tasks_cost}
                    label={"Facility Tasks Cost"}
                    // label={allTime ? "Total Units" : "Total Units"}
                    // sublabel={allTime ? "All-time Expenditure (PKR)" : `${moment(selectedMonth).format("MMM YYYY")} Expenditure (PKR)`}
                  />

                  <KPI
                    icon={Package}
                    value={dashboardData?.cost_summary?.consumables_cost}
                    label={"Consumables Cost"}
                    // sublabel={allTime ? "Lifetime Quantity" : `${moment(selectedMonth).format("MMM YYYY")} Quantity`}
                  />

                  <KPI
                    icon={BarChart3}
                    value={dashboardData?.cost_summary?.grand_total}
                    label={"Grand Total"}
                    // sublabel={allTime ? "All-time Average per Entry" : `${moment(selectedMonth).format("MMM YYYY")} Average per Entry`}
                  />
                </>
              ) : (
                Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mt-6">
              {/* Line Chart */}
              <Card className="col-span-3 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <TrendingUp className="h-5 w-5" /> Repair By Location
                  </CardTitle>
                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={true} className="btnClass">
                      <h3 className="!text-[16px]">{activeMainChart}</h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      {activeMainChart != "By Cost" && (
                        <CustomDropdownMenuList
                          onClick={() => {
                            setActiveMainChart("By Cost");
                          }}
                        >
                          <div
                            className={
                              "d-flex whitespace-normal align-items-center gap-1"
                            }
                          >
                            By Cost
                          </div>
                        </CustomDropdownMenuList>
                      )}
                      {activeMainChart != "By Count" && (
                        <CustomDropdownMenuList
                          onClick={() => {
                            setActiveMainChart("By Count");
                          }}
                        >
                          <div
                            className={
                              "d-flex whitespace-normal align-items-center gap-1"
                            }
                          >
                            By Count
                          </div>
                        </CustomDropdownMenuList>
                      )}
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </CardHeader>
                <CardContent>
                  {
                    isTrendLoad ? (
                      <HighchartsReact highcharts={Highcharts} options={monthlyChart} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" />
                    Repair By Status
                  </CardTitle>
                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={true} className="btnClass">
                      <h3 className="!text-[16px]">{activeChart}</h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      {activeChart != "By Cost" && (
                        <CustomDropdownMenuList
                          onClick={() => {
                            setActiveChart("By Cost");
                          }}
                        >
                          <div
                            className={
                              "d-flex whitespace-normal align-items-center gap-1"
                            }
                          >
                            By Cost
                          </div>
                        </CustomDropdownMenuList>
                      )}
                      {activeChart != "By Count" && (
                        <CustomDropdownMenuList
                          onClick={() => {
                            setActiveChart("By Count");
                          }}
                        >
                          <div
                            className={
                              "d-flex whitespace-normal align-items-center gap-1"
                            }
                          >
                            By Count
                          </div>
                        </CustomDropdownMenuList>
                      )}
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </CardHeader>
                <CardContent>
                  {isDashboardApiLoaded ? (
                    pieOptions?.series?.some(serie => serie.data && serie.data.length > 0) ? (
                      <HighchartsReact highcharts={Highcharts} options={pieOptions} />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <DataNotFound title={activeChart.replaceAll("By", "")} />
                      </div>
                    )
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* <div className="flex flex-col gap-2">
                <KPI
                  icon={Wallet}
                  value={auditData?.overdueUnpaid?.length}
                  label={"Over Due Unpaid"}
                  extraClass={quickOpenData?.title == "Over Due Unpaid" ? "theme" : ""}
                  onClick={() => {
                    setQuickOpenData({
                      isOpen: true,
                      icon: <Wallet />,
                      title: "Over Due Unpaid",
                      data: auditData?.overdueUnpaid,
                      header:[
                        {key: "billing_month", value: "Billing Month"}, 
                        {key: "due_date", value: "Due Date"},
                        {key: "location", value: "Location"}, 
                        {key: "amount", value: "Amount"},
                        {key: "days_overdue", value: "Days Overdue"},
                        {key: "issue", value: "Issue"},
                        {key: "severity", value: "Severity"},
                      ]
                    })
                  }}
                  // sublabel={`Current Month Expenditure (PKR)`}
                />

                <KPI
                  icon={Wallet}
                  value={auditData?.abnormalSpike?.length}
                  label={"Abnormal Spike"}
                  extraClass={quickOpenData?.title == "Abnormal Spike" ? "theme" : ""}
                  onClick={() => {
                    setQuickOpenData({
                      isOpen: true,
                      icon: <Wallet />,
                      title: "Abnormal Spike",
                      data: auditData?.abnormalSpike,
                      header:[
                        {key: "month", value: "Month"}, 
                        {key: "previous_units", value: "Previous Units"},
                        {key: "current_units", value: "Current Units"}, 
                        {key: "issue", value: "Issue"},
                        {key: "severity", value: "Severity"},
                      ]
                    })
                  }}
                  // sublabel={`Current Month Expenditure (PKR)`}
                />

                <KPI
                  icon={Wallet}
                  value={auditData?.rateOutliers?.length}
                  label={"Rate Outliers"}
                  extraClass={quickOpenData?.title == "Rate Outliers" ? "theme" : ""}
                  onClick={() => {
                    setQuickOpenData({
                      isOpen: true,
                      icon: <Wallet />,
                      title: "Rate Outliers",
                      data: auditData?.rateOutliers,
                      header:[
                        {key: "billing_month", value: "Billing Month"}, 
                        {key: "rate_per_unit", value: "Rate Per Unit"},
                        {key: "rate_per_unit_range", value: "Rate Per Unit"}, 
                        {key: "issue", value: "Issue"},
                        {key: "severity", value: "Severity"},
                      ]
                    })
                  }}
                  // sublabel={`Current Month Expenditure (PKR)`}
                />
              </div> */}

              <div className="col-span-5">
                <TableCard>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {/* {quickOpenData?.header?.map((eachHead, i) => (
                          <TableCell header key={i}><TableHeaderWrap><span>{eachHead?.value}</span></TableHeaderWrap></TableCell>
                        ))} */}
                        <TableCell header><TableHeaderWrap><span>Asset Name</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Asset Code</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Office</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Total Repairs</span></TableHeaderWrap></TableCell>
                      </TableRow>
                    </TableHead>
  
                    <TableBody>
                      {dashboardData?.assets_with_most_repairs?.map((ele, idx) => (
                        <TableRow key={idx}>
                          {/* {quickOpenData?.header?.map((eachHead, i) => (
                            <>
                              {eachHead?.key == "severity" ?
                                <TableCell
                                  key={`${i}-${idx}`}
                                  className={`text-center`}
                                >
                                  {ele[eachHead?.key]?.toLowerCase() === "low" ? (
                                    <StatusChip color="green">{ele[eachHead?.key] || "--"}</StatusChip>
                                  ) : ele[eachHead?.key]?.toLowerCase() === "high" ? (
                                    <StatusChip color="red">{ele[eachHead?.key] || "--"}</StatusChip>
                                  ) : ele[eachHead?.key] === "critical" ? (
                                    <StatusChip color="purple">{ele[eachHead?.key] || "--"}</StatusChip>
                                  ) : (
                                    <StatusChip color="blue">{ele[eachHead?.key] || "--"}</StatusChip>
                                  )}
                                </TableCell>
                                :
                                (eachHead?.key == "location") ?
                                <TableCell key={`${i}-${idx}`}>
                                  <div className="flex flex-wrap gap-2 max-w-[550px]">
                                    <TableBuildingTag title={ele[eachHead?.key]} colorIndex={Number(ele[eachHead?.key]?.replaceAll("B", ""))} />
                                  </div>
                                </TableCell>
                                :
                                <TableCell>{ (eachHead?.key?.includes("month")) ? moment(ele[eachHead?.key], "YYYY-MM").format("MMM YYYY") : (eachHead?.key == "due_date") ? moment(ele[eachHead?.key], "YYYY-MM-DD").format("DD MMM YYYY") : ele[eachHead?.key]}</TableCell>
                              }
                              
                            </>
                          ))} */}
                          <TableCell>{ele?.asset_code}</TableCell>
                          <TableCell>{ele?.asset_name}</TableCell>
                          <TableCell><TableBuildingTag title={ele?.office} colorIndex={Number(ele?.office?.replaceAll("B", ""))} /></TableCell>
                          <TableCell>{ele?.total_repairs}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableCard>
              </div>

            </div>
          </TableCard>
        </div>
      </div>

      {/* {quickOpenData?.isOpen &&
        <OverviewQuickView data={quickOpenData} onClose={() => setQuickOpenData({isOpen: false})} />
      } */}
      

    </>
  );
}
